<template>
  <BarChart
    type="bar"
    :width="width"
    :height="height"
    :data="data"
    :options="options"
    customLegend
  />
</template>

<script setup>
import {  computed } from 'vue'

const props = defineProps({
  width: {
    type: Number,
    default: 0
  },
  height: {
    type: Number,
    default: 0
  },
  chartLabel:{
    type: Array,
    default: ()=>[]
  },
  series:{
    type: Array,
    default: ()=> []
  },
})
const data = computed(() => {
  return {
    labels: props.chartLabel,
    datasets: [
      {
        label: 'ไม่มีบ้านพักอาศัยเป็นหลักแหล่ง',
        barPercentage: 1,
        barThickness: 20,
        maxBarThickness: 20,
        minBarLength: 2,
        backgroundColor: '#1C4E80',
        data: props.series
      },
      {
        label: 'อาศัยอยู่กับผู้อื่นโดยไม่เสียค่าเช่า',
        barPercentage: 1,
        barThickness: 20,
        maxBarThickness: 20,
        minBarLength: 2,
        backgroundColor: '#0091D5',
        data: [12,33,42,21,20,55,34,22,11]
      },
      {
        label: 'เช่าบ้านอยู่',
        barPercentage: 1,
        barThickness: 20,
        maxBarThickness: 20,
        minBarLength: 2,
        backgroundColor: '#A5D8DD',
        data: [20,10,28,10,23,15,34,53,22]
      },
      {
        label: 'อาศัยในบ้านพักสวัสดิการตามสิทธิที่ได้รับ',
        barPercentage: 1,
        barThickness: 20,
        maxBarThickness: 20,
        minBarLength: 2,
        backgroundColor: '#EA6A47',
        data: [9,19,20,11,24,26,35,37,48]
      },
      {
        label: 'อาศัยหรือปลูกบ้านในที่ดินผู้อื่น',
        barPercentage: 1,
        barThickness: 20,
        maxBarThickness: 20,
        minBarLength: 2,
        backgroundColor: '#DBAE58',
        data: [22,23,55,42,30,37,12,32,44]
      },
      {
        label: 'มีบ้านและที่ดินเป็นของตนเองแต่อยู่ระหว่างการผ่อนชำระ',
        barPercentage: 1,
        barThickness: 20,
        maxBarThickness: 20,
        minBarLength: 2,
        backgroundColor: '#1b6279',
        data: [55,43,15,62,20,32,34,36,46]
      },
      {
        label: 'มีบ้านและที่ดินเป็นของตนเองแต่ติดจำนองหรือค้ำประกัน',
        barPercentage: 1,
        barThickness: 20,
        maxBarThickness: 20,
        minBarLength: 2,
        backgroundColor: '#488A99',
        data: [55,43,15,62,10,12,14,22,54]
      },
      {
        label: 'มีบ้านและที่ดินเป็นของตนเองโดยไม่ต้องผ่อนชำระ',
        barPercentage: 1,
        barThickness: 20,
        maxBarThickness: 20,
        minBarLength: 2,
        backgroundColor: '#6AB187',
        data: [35,33,45,52,20,31,42,46,12]
      },
      {
        label: 'อื่น ๆ',
        barPercentage: 1,
        barThickness: 20,
        maxBarThickness: 20,
        minBarLength: 2,
        backgroundColor: '#7E909A',
        data: [42,33,25,52,40, 12, 15,23,45]
      }
    ]
  }
})
const options = computed(() => {
  return {
    indexAxis: 'y',
    scales: {
      x: {
        display: false,
        stacked: true,
        // grid: {
        //   display: false,
        // },
      },
      y: {
        stacked: true,
        // display: false,
        // grid: {
        //   display: false,
        //   drawBorder: false,
        // },
      }
    },
    plugins: {
      tooltip: {
        mode: 'index',
        callbacks: {
          title: function(tooltipItems, data) {
           let sum = 0;
            tooltipItems.forEach(function(tooltipItem) {
              sum += tooltipItem.raw;
            });
            return `${tooltipItems[0].label} (รวม: ${new Intl.NumberFormat().format(sum)})`;
          },
        }
      },
      legend: {
        labels: {
          fontSize: 14,
          boxWidth: 6
        },
        display: false,
        position: "bottom",
        align: "start",
        // onClick: function(e, legendItem, legend){
        //   const index = legendItem.datasetIndex;
        //   const type = legend.chart.config.type;
        //   console.log("ind", index, type);
          
        // }
      }
    },
    responsive:true,
  }
})


</script>
